import { DP_IDS_HOLDING, DP_TRANSACTION_HISTORY_HOLDING, DP_TRANSACTION_HISTORY_LOADER, DP_TRANSACTION_MAIN_LOADER, EMPTY_DP_TRANSACTION_VALIDATION, HIDE_EMPTY_DP_TRANSACTION_VALIDATION, HOLDING_EMPTY_VALIDATION, HOLDING_ERROR, HOLDING_HIDE_EMPTY_VALIDATION, HOLDING_HIDE_ERROR, HOLDING_LOADER, HOLDING_REPORT, PROD_ASSET_FILTER_VAL_HOLDING, SAVE_SMTF, SELECTED_ROW_INDEX, } from "../../interfaces/Reports/iHoldingReport";
import { FilterTabEnum } from "@frameworks/web/components/Reports/CommonComponent/constant";
const initState = {
    data: {
        HoldingSummary: {
            date: "",
            message: "",
            totalInvestment: "",
            currentValue: "",
            totalPnL: "",
            daysPnL: "",
            totalPnLChange: "",
            daysPnLChange: "",
            // time: ""
        },
        HoldingDetails: [],
        SearchData: "",
        FilterData: {
            simpleFilter: { name: "", filters: [] },
            assetFilter: { name: "", filters: [] },
            productAssetFilter: { name: "", filters: [] },
        },
        SortData: [],
        IsSummarize: false,
        HoldingDataFlags: {
            isOmneOnly: false,
            bodProcessInfoMessage: "",
            isBodEnabled: false
        }
    },
    loader: false,
    downloadStatus: {
        error: null,
        isOpen: null,
    },
    emailStatus: {
        error: null,
        isOpen: null,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    dpTransactionHistoryErrorData: {
        error: null,
        isOpen: false,
    },
    dpTransactionSubmitErrorData: {
        error: null,
        isOpen: false,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
    emptyDpTransaction: { icon: "", message: "" },
    dpTransactionEntity: {
        dpIds: [],
        dpTranactions: [],
    },
    dpTransactionLoader: false,
    dpTransactionMainLoader: false,
    prodDropDown: null,
    activeAssetTab: FilterTabEnum.ALL,
    smtf: false,
    selectedRowIndex: undefined,
};
const holdingReport = (state = initState, action) => {
    switch (action.type) {
        case HOLDING_REPORT:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case SELECTED_ROW_INDEX:
            return Object.assign(Object.assign({}, state), { selectedRowIndex: action.payload.selectedRowIndex });
        case HOLDING_LOADER:
            return Object.assign(Object.assign({}, state), { loader: action.payload.loader });
        case HOLDING_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case HOLDING_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initState[action.errorType] });
        case HOLDING_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case EMPTY_DP_TRANSACTION_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyDpTransaction: action.payload.emptyDpTransaction });
        case HOLDING_HIDE_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: initState.emptyValidation });
        case HIDE_EMPTY_DP_TRANSACTION_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyDpTransaction: initState.emptyDpTransaction });
        case DP_TRANSACTION_HISTORY_HOLDING:
            return Object.assign(Object.assign({}, state), { dpTransactionEntity: Object.assign(Object.assign({}, state.dpTransactionEntity), { dpTranactions: action.payload.dpTransactionEntity.dpTranactions }) });
        case DP_TRANSACTION_HISTORY_LOADER:
            return Object.assign(Object.assign({}, state), { dpTransactionLoader: action.payload.dpTransactionLoader });
        case DP_TRANSACTION_MAIN_LOADER:
            return Object.assign(Object.assign({}, state), { dpTransactionMainLoader: action.payload.dpTransactionMainLoader });
        case DP_IDS_HOLDING:
            return Object.assign(Object.assign({}, state), { dpTransactionEntity: Object.assign(Object.assign({}, state.dpTransactionEntity), { dpIds: action.payload.dpTransactionEntity.dpIds }) });
        case PROD_ASSET_FILTER_VAL_HOLDING:
            return Object.assign(Object.assign({}, state), { prodDropDown: action.payload.prodDropDown, activeAssetTab: action.payload.activeAssetTab });
        case SAVE_SMTF:
            return Object.assign(Object.assign({}, state), { smtf: action.payload.smtf });
        default:
            return Object.assign({}, state);
    }
};
export default holdingReport;
